/*
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { AbstractControl, ValidationErrors } from '@angular/forms';

export function notEmptyRequiredValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value || !control.value.trim()) {
    return { required: true };
  }

  return null;
}
